import Button from '../../../components/base/Button';

export default function CTASection() {
  const benefits = [
    { icon: 'ri-check-double-line', text: 'Free screening for new members' },
    { icon: 'ri-user-star-line', text: 'Professional trainer guidance' },
    { icon: 'ri-trophy-line', text: 'Over 100 premium machines' },
    { icon: 'ri-calendar-check-line', text: 'Flexible membership options' }
  ];

  return (
    <section className="py-12 lg:py-24 bg-black text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-0 w-96 h-96 bg-red-600 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-red-700 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-6 lg:gap-12 items-center">
          {/* Left: Content */}
          <div>
            <div className="inline-block px-2 py-1 lg:px-4 lg:py-2 bg-red-600/20 border border-red-500/50 rounded-lg text-[10px] lg:text-sm font-bold mb-3 lg:mb-6 uppercase tracking-wider text-red-400">
              START YOUR JOURNEY
            </div>

            <h3 className="text-2xl lg:text-6xl font-black mb-3 lg:mb-6 leading-tight tracking-tight">
              Transform Your Life at <span className="text-red-500">HFC Gym</span>
            </h3>

            <p className="text-xs lg:text-xl text-gray-300 mb-4 lg:mb-8 leading-relaxed">
              Join one of Kenya's biggest gyms in Eldoret. With over 100 premium machines, professional trainers, and affordable rates, everything you need to achieve your fitness goals is here.
            </p>

            {/* Benefits Grid */}
            <div className="grid grid-cols-2 gap-2 lg:gap-4 mb-4 lg:mb-8">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-2 lg:gap-3">
                  <div className="w-7 h-7 lg:w-10 lg:h-10 bg-red-600/20 border border-red-500/50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${benefit.icon} text-red-500 text-xs lg:text-lg`}></i>
                  </div>
                  <span className="text-gray-300 text-[10px] lg:text-sm">{benefit.text}</span>
                </div>
              ))}
            </div>

            {/* Pricing Highlight */}
            <div className="bg-gradient-to-br from-red-600/20 to-red-700/20 border border-red-500/30 rounded-xl lg:rounded-2xl p-3 lg:p-6 mb-4 lg:mb-8 backdrop-blur-sm">
              <div className="flex items-center justify-between flex-wrap gap-2 lg:gap-4">
                <div>
                  <p className="text-gray-400 text-[10px] lg:text-sm mb-0.5">Daily Pass</p>
                  <p className="text-xl lg:text-3xl font-black text-white">KES 500</p>
                </div>
                <div className="h-8 lg:h-12 w-px bg-gray-700"></div>
                <div>
                  <p className="text-gray-400 text-[10px] lg:text-sm mb-0.5">Monthly Membership</p>
                  <p className="text-xl lg:text-3xl font-black text-white">KES 4,650</p>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-wrap gap-2 lg:gap-4">
              <Button
                href="tel:+254795568891"
                variant="cta"
                icon="ri-phone-line"
                iconPosition="left"
                className="text-xs lg:text-base px-4 py-2 lg:px-8 lg:py-4"
              >
                Call: 0795 568 891
              </Button>
              <Button
                href="#contact"
                variant="secondary"
                icon="ri-map-pin-line"
                iconPosition="left"
                className="text-xs lg:text-base px-4 py-2 lg:px-8 lg:py-4"
              >
                Get Directions
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="flex items-center gap-4 lg:gap-6 mt-4 lg:mt-8 pt-4 lg:pt-8 border-t border-gray-800">
              <div className="flex items-center gap-1.5 lg:gap-2">
                <i className="ri-shield-check-fill text-red-500 text-base lg:text-2xl"></i>
                <span className="text-[10px] lg:text-sm text-gray-400 uppercase tracking-wide">Clean Facilities</span>
              </div>
              <div className="flex items-center gap-1.5 lg:gap-2">
                <i className="ri-star-fill text-red-500 text-base lg:text-2xl"></i>
                <span className="text-[10px] lg:text-sm text-gray-400 uppercase tracking-wide">Professional Trainers</span>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="relative rounded-xl lg:rounded-2xl overflow-hidden shadow-2xl shadow-red-600/20 w-full h-[250px] lg:h-[600px] border-2 border-gray-800">
              <img
                src="https://static.readdy.ai/image/6d19b89fe3829a5047d14ddaa9a9b93d/a251dd2f17deb57173ab1078b0139e78.png"
                alt="Join HFC Gym"
                className="w-full h-full object-cover object-center"
              />
            </div>

            {/* Floating Stats - Hidden on mobile */}
            <div className="hidden lg:block absolute -bottom-6 -left-6 bg-gray-900 border-2 border-red-600 rounded-xl p-6 shadow-2xl">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center">
                  <i className="ri-user-add-line text-white text-2xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-black text-white">500+</div>
                  <div className="text-sm text-gray-400 uppercase tracking-wide">Active Members</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
